module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td colspan="6">'+
((__t=(t('subscription::payment-history:table:empty')))==null?'':_.escape(__t))+
'</td>';
}
return __p;
};